<template>
    <div class="text-wrapper">
        <div class="img-center"><img src="@/assets/logo_umc.jpg"/></div>
        <img class="large" src="@/assets/umc_banner.jpg"/>
    </div>
</template>

<script>
    export default {
        name: 'v-top-images'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .text-wrapper{
        h1{
            font-size:1.4em;
        }
        .large{
            width:325px;
            display:block;
            margin:auto;
        }
        .img-center{
            text-align:center;
            margin:40px 0;
            img{
                height:55px;
            }
        }
        .warning-text{
            text-align:center;
            font-size:1.4em;
            .red{
                color:#f90202;
            }
        }
        font-size:1.2em;
    }
</style>
